<template>

    <div class="hero">
        <div class="title_notice_line">
            <div class="coeffs_heading container">
                <h1 class="page-title title is-size-2 has-text-weight-bold">Nom de votre référentiel</h1>
                <!-- <notifText v-html="$t('modules.refs.formStep4.globalNotice')" /> -->
                <div  class="notification_text is-default">Entrez le nom pour votre référentiel afin de pouvoir le retrouver parmis vos référentiels personnels</div>
            </div>
        </div>
        <div class="hero-body team_fit_form_wrapper">
            
            <div class=" bottom-section container">
                <!-- <div class="model_align_btn small_margin" @click="syncScores" >
                    <span>{{ $t('modules.refs.formStep4.SyncRefButton') }}</span>
                    <div class="btn_tick">
                        <div class="btn_inner_tick"></div>
                    </div>
                </div> -->
                <div class="container mini-container has-text-centered ">


                <InputMaterialWrap 
                    v-model="teamRef.name"
                    label=""
                    class="big_input"
                    validate='required'
                    input-id="refName"
                    @input="updateRefName">
                </InputMaterialWrap>

                <div class="has-text-centered">
                    <button class="button  is-info is-rounded is-outlined" @click="saveRef()" :disabled="!isFormValid">
                        {{ $t('modules.positions.teamFit.saveRef') }}
                    </button>
                </div>

            </div>
                
            </div>

        </div>
    </div>

</template>

<script>
    export default {
        name: 'TeamFitRefName',
        props: ['teamRef'],
        components: {},
        created(){},
        data(){
            return {}
        },
        computed: {
            isFormValid(){
                return  this.teamRef.name != ''
            }
        },
        methods: {
            updateRefName(val){
                this.teamRef.name = val
            },
            saveRef(){
                this.$store.dispatch("RefStore/createRef", this.teamRef).then((returnedRef) => {
                    this.$emit("refSaved", "refSaved", returnedRef)
                })

            }
        }
    }
</script>

<style lang="scss" scoped>
.team_fit_form_wrapper{
    background: white;
}
</style>
